import React, { useState, useRef, useCallback } from 'react';
import { useSearchToolbarContext } from "./hooks";
import "./DisplayMode.scss";

export const DISPLAYMODE = {
    GRIDCOMPACT: 'grid-compact',
    GRIDEXPANDED: 'grid-expanded',
    LIST: 'list',
  };

function DisplayMode() {
    const {
        displaymode: {
            option1 = { value: "", label: "", className: "" },
            option2 = { value: "", label: "", className: "" },
            option3 = { value: "", label: "", className: "" },
            defaultSelected,
            label,
            name,
            ariaLabel,
            onChange,
            hidden = false,
        },
    } = useSearchToolbarContext();

    // Filter out null options and get valid values
    const validOptions = [option1, option2, option3].filter(opt => opt && opt.value);
    const validValues = validOptions.map(opt => opt.value);
    const validDefaultSelected = validValues.includes(defaultSelected) ? defaultSelected : validValues[0];
    const [selected, setSelected] = useState(validDefaultSelected);

    // Add refs for each input
    const input1Ref = useRef();
    const input2Ref = useRef();
    const input3Ref = useRef();

    const handleToggle = useCallback((option) => {
        setSelected(option);
        if (onChange) onChange(option);
    }, [onChange]);

    React.useEffect(() => {
        setSelected(validDefaultSelected);
    }, [validDefaultSelected]);

    return !hidden && (
        <div>
            <fieldset
                aria-label={ariaLabel}
                role="radiogroup"
                className="toggle-icon-switch"
            >
                {label && <label className="toggle-icon-switch__label-text">{label}:</label>}
                <div className="toggle-icon-switch__options-wrapper">
                    {option1 && option1.value && (
                        <label
                            htmlFor={option1.value}
                            className={`toggle-icon-switch__option-label ${selected === option1.value ? "selected" : ""}`}
                            data-tooltip={option1.label}
                            onMouseLeave={() => {
                                if (input1Ref.current) input1Ref.current.blur();
                            }}
                        >
                            <input
                                ref={input1Ref}
                                type="radio"
                                id={option1.value}
                                name={name}
                                value={option1.value}
                                title={option1.label}
                                data-tooltip={option1.label}
                                checked={selected === option1.value}
                                onChange={() => handleToggle(option1.value)}
                                aria-checked={selected === option1.value}
                                onMouseUp={e => e.currentTarget.blur()}
                                onBlur={e => e.currentTarget.blur()}
                            />
                            <span className={option1.className} aria-hidden="true"></span>
                        </label>
                    )}
                    {option2 && option2.value && (
                        <label
                            htmlFor={option2.value}
                            className={`toggle-icon-switch__option-label ${selected === option2.value ? "selected" : ""}`}
                            data-tooltip={option2.label}
                            onMouseLeave={() => {
                                if (input2Ref.current) input2Ref.current.blur();
                            }}
                        >
                            <input
                                ref={input2Ref}
                                type="radio"
                                id={option2.value}
                                name={name}
                                value={option2.value}
                                title={option2.label}
                                checked={selected === option2.value}
                                onChange={() => handleToggle(option2.value)}
                                aria-checked={selected === option2.value}
                                onMouseUp={e => e.currentTarget.blur()}
                                onBlur={e => e.currentTarget.blur()}
                            />
                            <span className={option2.className} aria-hidden="true"></span>
                        </label>
                    )}
                    {option3 && option3.value && (
                        <label
                            htmlFor={option3.value}
                            className={`toggle-icon-switch__option-label ${selected === option3.value ? "selected" : ""}`}
                            data-tooltip={option3.label}
                            onMouseLeave={() => {
                                if (input3Ref.current) input3Ref.current.blur();
                            }}
                        >
                            <input
                                ref={input3Ref}
                                type="radio"
                                id={option3.value}
                                name={name}
                                value={option3.value}
                                title={option3.label}
                                checked={selected === option3.value}
                                onChange={() => handleToggle(option3.value)}
                                aria-checked={selected === option3.value}
                                onMouseUp={e => e.currentTarget.blur()}
                                onBlur={e => e.currentTarget.blur()}
                            />
                            <span className={option3.className} aria-hidden="true"></span>
                        </label>
                    )}
                </div>
            </fieldset>
        </div>
    );
}

export default DisplayMode;